export default {
  sections: {
    address: 'Virksomhedsadresse',
    address_help: 'Indtast den adresse, din virksomhed er registreret på. Den vises på dine fakturaer.',
  },
  form: {
    legal_form: {
      label: 'Virksomhedstype',
      help: 'En UG (haftungsbeschränkt) er en GmbH her, en e.K. en enkeltmandsvirksomhed. For en OHG eller KG bedes du kontakte support.',
      options: {
        sole_trader: 'Enkeltmandsvirksomhed',
        gbr: 'GbR',
        gmbh: 'GmbH / UG',
      },
    },
    legal_name: {
      label: 'Registreret virksomhedsnavn',
      placeholder: 'Indtast det registrerede virksomhedsnavn',
      sole_trader_help: 'Lad stå tom, hvis du handler under dit eget navn',
    },
  },
  buttons: {
    next: 'Næste',
  },
};
